var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4989 23.8277C6.05748 23.8277 0.835999 18.6063 0.835999 12.1648C0.835999 5.72343 6.05748 0.501953 12.4989 0.501953C18.9403 0.501953 24.1618 5.72343 24.1618 12.1648C24.1618 18.6063 18.9403 23.8277 12.4989 23.8277ZM11.3361 16.83L19.5818 8.58317L17.9338 6.93404L11.3361 13.5317L8.03667 10.2323L6.38754 11.8814L11.3361 16.83Z",
    fill: "#FF6B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.3322ac9bc68bcb58d088537073a143e9.svg";
export { ForwardRef as ReactComponent };